var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 67,
    height: 67,
    rx: 10,
    fill: "#cfcfcf",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Message",
    "data-name": "Iconly Two-tone Message",
    transform: "translate(15.419 16.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M2003.16,1646.912l-8.222,6.618a4.283,4.283,0,0,1-5.292,0l-8.292-6.618",
    transform: "translate(-1973.733 -1636.194)",
    fill: "none",
    stroke: "#cfcfcf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    d: "M1986.82,1641.351h18.171a9.553,9.553,0,0,1,6.908,3.065,9.666,9.666,0,0,1,2.555,7.131v12.582a9.666,9.666,0,0,1-2.555,7.131,9.552,9.552,0,0,1-6.9,3.064H1986.82c-5.627.016-9.42-4.562-9.42-10.188v-12.582C1977.4,1645.928,1981.193,1641.351,1986.82,1641.351Z",
    transform: "translate(-1977.4 -1641.351)",
    fill: "none",
    stroke: "#cfcfcf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareEmail);
export default __webpack_public_path__ + "static/media/square-email.e1698200e781da8b360888850f7b7a00.svg";
export { ForwardRef as ReactComponent };